<template>

    <div class="row">
        <div class="col-md-12">
            <div class="card">
                <div class="card-body">
                  
                        

                                <form @submit.prevent="save" v-if="entity">
                                    <div class="row">
                                          <div class="col-12">

                                            <ValidationProvider v-slot="{ classes, errors }" immediate slim rules="required">
                                                <div class="form-group">
                                                    <label class="col-form-label" for="descrizione">Descrizione</label>
                                                    <input type="text" id="descrizione" name="descrizione" placeholder="Descrizione tag" v-model="entity.description" class="form-control" :class="classes">
                                                    <!--<span :class="classes">{{ errors[0] }}</span>-->
                                                </div>

                                            </ValidationProvider>

                                        </div>
                                        <div class="col-12">
                                            <label class="col-form-label" for="tagTypeId">Tipologia</label>
                                            <select v-model="entity.tagTypeId" name="tagTypeId" class="form-control">
                                                <option v-for="tt in tagTypes" :value="tt.tagTypeId">{{tt.description}}</option>
                                            </select>

                                        </div>

                                    </div>




                                        <div class="form-group mt-3">
                                            <button type="button" class="btn btn-xs  btn-primary-rgba mr-2" v-on:click="save">Salva  <font-awesome-icon :icon="['far','save']"></font-awesome-icon></button>
                                            <button type="button" class="btn btn-xs  btn-danger-rgba  mr-2" v-on:click="cancel">Annulla  <font-awesome-icon :icon="['far','times-circle']"></font-awesome-icon></button>
                                        </div>
</form>
                               
                        

                    </div>
                </div>
            </div>
        </div>
       



</template>

<script>
    import Editor from '@tinymce/tinymce-vue'
    import axios from 'axios'
    import { Chrome } from 'vue-color';
    import { Slider } from 'vue-color';
    export default {
        data() {
            return {
                entity: null,
                colors: '#FFFFFF',
               
            };
        },
        computed: {
            tagTypes: function() {
                return this.$store.state.tagTypes;
            },
            tinyKey: function () {
                return window.SETTINGS.TinyApiKey;
            }
        },
        components: {
            Editor,
             'chrome-picker': Chrome
        },
        name: 'TagTypeSave',
        beforeMount() {
            var me = this;
          

           
            axios.get("tag/" + me.$route.params.id||'00000000-0000-0000-0000-000000000000').then(response => {
               
                                me.entity = response.data;
                                if(me.entity.description && me.entity.description!=''){
 me.$store.state.breadCrump.title = me.entity.description;

                                }
            })



        },
        methods: {
            cancel() {
                this.$router.push({
                    name: "route-tagtype-list",

                    replace: true
                });
            },
           
              updateFromPicker(color) {
                this.entity.backgroundColor = color.hex;
            },
            save() {
                let me = this;
                axios.post("tag", this.entity).then(response => {
                    if (me.$route.params.id != response.data.tagId) { me.$router.push({ name: 'route-tag-edit', params: { id: response.data.tagId } }); }

                    me.$swal(
                                    {
                                        title: "Salvataggio avvenuto correttamente",
                                        text: "",
                                        type: "success",
                                        showCancelButton: false,
                                        toast: true,
                                        timer: 2000,
                                        showConfirmButton: false,
                                        position: "bottom-top"
                        });
                })
            }
        }
    };
</script>
